import React, { useId } from "react";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
} from "@gc-npm/components.text";
import PillCapacity from "@/component/pill-capacity";
import ColorRow from "@/component/color-row";

import { CAPACITY, COLOR } from "@/constants/device-detail";
import {
  checkIfColorOfferIsEmpty,
  checkIfCapacityOfferIsEmpty,
} from "@/utils/dataHandlerDetailedProduct";

import styles from "./style";

const RowCapacityColor = ({
  offer,
  selectedCapacity,
  capacities,
  selectedColor,
  nameSelectedColor,
  displayedCapacityText,
  colors,
  onClick,
  clientType,
  cydata,
  showTitle = true,
}) => {
  const capacityGroupName = useId();

  return (
    <>
      <section className={`row-capacity-color${cydata ? ` ${cydata}` : ""}`}>
        {showTitle && (
          <div className="row-capacity-color--title">
            <TextInfo
              text={capacities ? (displayedCapacityText ? `${displayedCapacityText}:` : CAPACITY) : COLOR}
              size={TEXT_SIZE.SUBTITLE2}
              color={TEXT_COLOR.GREY_700}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
            <TextInfo
              text={`${capacities ? selectedCapacity : nameSelectedColor}`}
              size={TEXT_SIZE.SUBTITLE2}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
          </div>
        )}
        {colors && Array.isArray(colors) && colors.length > 0 ? (
          <div className="row-capacity-color--content">
            <ColorRow
              colors={colors
                .filter(
                  (color) =>
                    !checkIfColorOfferIsEmpty(
                      offer[color],
                      clientType,
                      selectedColor,
                      selectedCapacity
                    )
                )
                .map((color) => ({
                  colorHex: color,
                  colorName: offer[color].colorName,
                }))}
              selectedColorHex={selectedColor}
              onSelect={onClick}
              componentName="row-capacity-color"
            />
          </div>
        ) : (
          capacities &&
          Array.isArray(capacities) &&
          capacities.length > 0 && (
            <ul
              className="row-capacity-color--content"
              role="radiogroup"
              aria-label={displayedCapacityText || CAPACITY}
            >
              {capacities.map(
                (capacity) =>
                  !checkIfCapacityOfferIsEmpty(
                    offer,
                    capacity,
                    clientType,
                    selectedColor,
                    selectedCapacity
                  ) && (
                    <PillCapacity
                      key={`pill-category-${capacity}`}
                      name={`capacity-${capacityGroupName}`}
                      onClick={() => onClick(capacity)}
                      capacity={capacity}
                      isSelected={capacity === selectedCapacity}
                    />
                  )
              )}
            </ul>
          )
        )}
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default RowCapacityColor;
